import intl from 'react-intl-universal'

export default {
  type: 'gallery',
  title: `Gallery`,
  icon: `th-large`,
  interfaceApi: '/photo/galleries/selector/?select=multiple',
  template: `<figure class="feature-wrapper" contenteditable="false">
               <img contenteditable="false" src="{{feature.promo_items.basic.additional_properties.proxyUrl || feature.content_elements[0].additional_properties.proxyUrl || feature.content_elements[0].url || feature.promo_items.basic.url}}" alt="{{feature.content_elements[0]._id}}">
               <div data-update-text="true" contenteditable="false" class="info-bar py-3">
                 <i class="fa fa-th-large"></i> ${intl.get(
                   'blocks.gallery.galleryLabel'
                 )} &nbsp;|&nbsp <strong>${intl.get(
    'blocks.gallery.titleLabel'
  )}:</strong> &quot;{{feature.headlines.basic}}&quot;
                 <span ng-show="!feature.additional_properties.published" class="ng-hide pull-right unpublished"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> ${intl.get(
                   'blocks.image.unpublishedBadge'
                 )}</span>

                 <span ng-show="feature.additional_properties.published" class="ng-hide pull-right published">${intl.get(
                   'blocks.image.publishedBadge'
                 )}</span>

                 <div ng-if="feature.description.basic">
                   <strong>${intl.get(
                     'blocks.gallery.descriptionLabel'
                   )}:</strong> {{feature.description.basic}}
                 </div>
                 <div class="mt-1">
                   <button type="button" class="btn btn-primary btn-sm" ng-click="showPropModal(index)" title=${intl.get(
                     'blocks.image.buttons.edit'
                   )}>${intl.get('blocks.image.buttons.edit')}</button>
                 </div>
               </div>
             </figure>`,
  preview: function (feature) {
    const galleryId = feature._id
    if (galleryId) {
      window.open('/photo/gallery/' + galleryId)
    }
  },
  propertyTemplate: `
      <div class="form-group row" ng-if="$root.globalSettingsModel.mediaOptions.gallery.showTitle">
        <label>Title</label>
        <textarea
          rows="5"
          smart-quote-handler
          class="form-control"
          ng-model="feature.headlines.basic"
          ng-change="feature.referent_properties.headlines = feature.referent_properties.headlines || {}; feature.referent_properties.headlines.basic = feature.headlines.basic"></textarea>
      </div>
      <div class="form-group row" ng-if="$root.globalSettingsModel.mediaOptions.gallery.showDescription">
        <label>Description</label>
        <textarea
          rows="10"
          smart-quote-handler
          class="form-control"
          ng-model="feature.description.basic"
          ng-change="feature.referent_properties.description = feature.referent_properties.description || {}; feature.referent_properties.description.basic = feature.description.basic"></textarea>
      </div>
      <div class="row" ng-if="$root.globalSettingsModel.mediaOptions.noGalleryFields">
        <p>No fields to edit, see 'Media Options' in settings to configure</p>
      </div>
    `,
}
